import { IControl } from "../icontrol";
import { ControlType } from "../../controltype";

/**
 * 日期区间带时间控件
 */
export class DateRangeTimeControl implements IControl{

    /**
     * 获取控件类型
     */
    getControlType(): ControlType {
        return ControlType.DateRangeTime;
    }

    /**
     * 默认显示
     */
    placeholder:string;
    beginPlaceHolder:string;
    endPlaceHolder:string;
    /**
     * 日期格式
     */
    format:string;
    /**
     * 是否是展示在扩展区域内的
     */
    isExtend:boolean;
    
    /**是否显示label */
    showLabel:boolean;
    /**是否必填 */
    required:boolean;
}